<template>
  <section class="home_content">

    <!-- 全局鼠标光晕 -->
    <div class="cursor-glow" ref="cursorGlow"></div>

    <!-- =================== Hero =================== -->
    <div class="hero" ref="hero">
      <!-- 悬浮光球 -->
      <div class="orb orb--1" ref="orb1"></div>
      <div class="orb orb--2" ref="orb2"></div>
      <div class="orb orb--3" ref="orb3"></div>

      <el-carousel
        indicator-position="outside"
        :autoplay="false"
        arrow="always"
        style="height:100%;position:relative;z-index:1;"
        @change="onSlideChange"
      >
        <el-carousel-item
          v-for="(item, idx) of bannerData"
          :key="idx"
          style="height:100%;"
        >
          <div
            class="hero__slide"
            :style="{ backgroundImage: 'url(' + item.img + ')' }"
          >
            <div class="hero__overlay"></div>
            <div class="hero__body">
              <div class="hero__badge" ref="heroBadge">
                <span class="hero__dot"></span>SaaS 数字化采购平台
              </div>
              <!-- 每行文字用 clip-wrap 包裹实现遮幕揭示 -->
              <div class="clip-wrap">
                <h1 class="hero__title clip-inner">{{ item.title }}</h1>
              </div>
              <div class="clip-wrap" style="margin-top:.75rem;">
                <p class="hero__sub clip-inner">{{ item.content1 }} · {{ item.content2 }}</p>
              </div>
              <div class="hero__actions" ref="heroActions">
                <button class="btn-primary magnetic" @click="applyShow">立即申请试用</button>
                <button class="btn-ghost magnetic">了解更多</button>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- =================== 统计数字 =================== -->
    <div class="stats-bar" ref="statsBar">
      <div class="stats-bar__inner">
        <div
          v-for="s in statsData"
          :key="s.label"
          class="stat-item"
        >
          <div class="stat-item__num-wrap">
            <span class="stat-item__num" :data-target="s.num" ref="statNums">0</span>
            <span class="stat-item__unit">{{ s.unit }}</span>
          </div>
          <p class="stat-item__label">{{ s.label }}</p>
        </div>
      </div>
    </div>

    <!-- =================== 产品服务 — 横向钉住滚动 =================== -->
    <div class="prod-section" ref="prodSection">
      <div class="prod-container">
        <!-- 左侧固定标题 -->
        <div class="prod-left">
          <span class="sec__label reveal-chip">PRODUCT SERVICE</span>
          <div class="title-mask">
            <h2 class="title-mask__inner sec__title" ref="prodTitle">我们的<br />产品服务</h2>
          </div>
          <p class="sec__desc" ref="prodDesc">推动企业采购更加<br />智能、高效、透明</p>
          <!-- 进度条 -->
          <div class="prod-progress">
            <div class="prod-progress__fill" ref="progressFill"></div>
          </div>
        </div>
        <!-- 右侧横向轨道 -->
        <div class="prod-overflow" ref="prodOverflow">
          <div class="prod-track" ref="prodTrack">
            <div
              v-for="item of productData"
              :key="item.title"
              class="prod-card"
              ref="prodCards"
            >
              <div class="prod-card__img">
                <img :src="item.img" :alt="item.title" />
              </div>
              <div class="prod-card__body">
                <h3>{{ item.title }}</h3>
                <p>{{ item.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- =================== 糖德 APP =================== -->
    <div class="sec sec--tint" ref="appSection">
      <div class="sec__inner app-section">
        <div class="app-section__text" ref="appText">
          <span class="sec__label reveal-chip">APP INTRODUCTION</span>
          <div class="title-mask">
            <h2 class="title-mask__inner sec__title" style="text-align:left;" ref="appTitle">我们的糖德商户APP</h2>
          </div>
          <p class="app-intro" ref="appIntroP">
            糖德APP是由厦门鸿宁兴科技有限公司设计与开发的一款商户数字化经营的APP，让传统实体商家通过新兴互联网金融技术实现智慧经营、智能收银、线上开店，帮助商家更好地进行数字化经营转型，助力商家拓展客源、增加销售额。
          </p>
          <h4 class="app-feat-title" ref="appFeatTitle">软件功能</h4>
          <ul class="app-feat-list">
            <li v-for="(feat, i) in appFeats" :key="i" class="app-feat-item" ref="appFeatItems">
              <span class="feat-num">0{{ i + 1 }}</span>
              <span>{{ feat }}</span>
            </li>
          </ul>
          <button class="btn-primary magnetic" @click="downlink" ref="appBtn">下载安装 APP</button>
        </div>
        <div class="app-section__img" ref="appImg">
          <div class="app-img-glow"></div>
          <img src="../assets/home.png" alt="糖德APP" />
        </div>
      </div>
    </div>

    <!-- =================== 服务价值 (FZ 移动版，隐藏) =================== -->
    <div class="sec sec--white productFz" style="display:none;">
      <div class="sec__inner" ref="product2">
        <div class="sec__head">
          <span class="sec__label">SERVICE VALUE</span>
          <h2 class="sec__title">我们的服务价值</h2>
        </div>
        <div class="service-wrap">
          <el-carousel indicator-position="none" arrow="always" :autoplay="false" style="height:33.3125rem;" class="carousel_you">
            <el-carousel-item v-for="ite of serviceData2" :key="ite.id" style="height:33.3125rem;" class="carousel_you1">
              <div class="service_bao">
                <div v-for="item of ite.valueData2" :key="item.text">
                  <div class="service_con" @mouseenter="onMouseOver2(item)" @mouseleave="onMouseOut2">
                    <div class="service_hover" v-if="item.type=='1'">
                      <img src="../assets/zu38.png" />
                      <div class="service_hover__text">
                        <span>{{ item.text }}</span><span class="service_hover__line"></span><span>{{ item.html }}</span>
                      </div>
                    </div>
                    <div class="service_zhan" v-else>
                      <img :src="item.img" /><span>{{ item.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <!-- =================== 服务价值 (PC版) =================== -->
    <div class="sec sec--svc productYs" ref="svcSection">
      <div class="sec__inner">
        <div class="sec__head" ref="svcHead">
          <span class="sec__label reveal-chip">SERVICE VALUE</span>
          <div class="title-mask">
            <h2 class="title-mask__inner sec__title">我们的服务价值</h2>
          </div>
          <p class="sec__desc">覆盖企业餐饮全场景，一站式数字化解决方案</p>
        </div>

        <!-- 4×2 特性卡片网格 -->
        <div class="svc-grid">
          <div
            v-for="(item, i) in flatServiceItems"
            :key="i"
            class="svc-card"
            ref="svcCards"
          >
            <!-- 序号角标 -->
            <span class="svc-card__index">{{ String(i + 1).padStart(2, '0') }}</span>
            <!-- 图标 -->
            <div class="svc-card__icon">
              <img :src="item.img" :alt="item.text" />
            </div>
            <h3 class="svc-card__title">{{ item.text }}</h3>
            <p class="svc-card__desc">{{ item.html }}</p>
            <!-- hover 时底部渐变线 -->
            <div class="svc-card__line"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- =================== Ticker Band =================== -->
    <div class="ticker-band">
      <div class="ticker-track" ref="tickerTrack">
        <span v-for="(w, i) in tickerWords.concat(tickerWords)" :key="i" class="ticker-item">{{ w }}</span>
      </div>
    </div>

    <!-- =================== 为什么选择我们 =================== -->
    <div class="sec sec--dark why-section" ref="whySection">
      <!-- 网格纹背景 -->
      <div class="why-grid-bg"></div>
      <!-- scrub 扫描线 -->
      <div class="why-scan-line" ref="whyScanLine"></div>
      <div class="sec__inner" style="position:relative;z-index:1;">
        <div class="sec__head" ref="whyHead">
          <span class="sec__label sec__label--light reveal-chip">CHOOSE US</span>
          <div class="title-mask">
            <h2 class="title-mask__inner sec__title sec__title--light">为什么选择我们</h2>
          </div>
          <p class="sec__desc sec__desc--light">多维度优势，助力企业数字化升级</p>
        </div>
        <div class="why-grid">
          <div
            v-for="item of usData"
            :key="item.title"
            class="why-card"
            ref="whyCards"
          >
            <div class="why-card__icon">
              <img :src="item.img" :alt="item.title" />
            </div>
            <h3 class="why-card__title">{{ item.title }}</h3>
            <p class="why-card__text">{{ item.content }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- =================== 合作伙伴 — 无限跑马灯 =================== -->
    <div class="partner-section" ref="partnerSection">
      <div class="sec__inner" style="max-width:1400px;margin:0 auto;padding:5rem 7.5rem 2.5rem;">
        <div class="sec__head" ref="partnerHead">
          <span class="sec__label reveal-chip">COOPERATIVE PARTNER</span>
          <div class="title-mask">
            <h2 class="title-mask__inner sec__title">我们的合作伙伴</h2>
          </div>
          <p class="sec__desc">与每一种力量，共筑智慧、便捷、美好生活</p>
        </div>
      </div>
      <!-- 全宽跑马灯轨道 -->
      <div class="marquee-outer">
        <div class="marquee-track" ref="marqueeTrack">
          <div
            v-for="(item, i) in marqueeLogos"
            :key="i"
            class="marquee-logo"
          >
            <img :src="item.img" />
          </div>
        </div>
      </div>
      <div style="height:3rem;"></div>
    </div>

    <ApplyDialog :show.sync="show"></ApplyDialog>
  </section>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import ApplyDialog from '../components/applyDialog.vue'

gsap.registerPlugin(ScrollTrigger)

export default {
  components: { ApplyDialog },
    data() {
    return {
      show: false,
      tickerWords: [
        '数字化采购', 'SAAS 平台', '智慧餐饮', '多端互通',
        '刷脸支付', '数据分析', '企业福利', '全天候支持', '软硬件结合',
      ],
      statsData: [
        { num: 500,  unit: '+', label: '合作商户' },
        { num: 10,   unit: '+', label: '年行业经验' },
        { num: 99,   unit: '%', label: '服务稳定性' },
        { num: 6,    unit: '×24h', label: '技术支持' },
      ],
      appFeats: [
        '实时账本功能，交易账单实时显示，账本交易首页即可查看最新收款信息。记账数据折叠汇总，进行统计分析，并同步收款数据，店铺总账一目了然。',
        '用户管理功能，用户精细化管理，商家可在手机端查看用户消费情况、处理用户退款信息。',
        '订单管理功能，通过订单功能，实现对线上订单、线下订单的管理，支持订单接收，方便商户查看、操作订单，实时高效的来对订单进行处理。',
      ],
      bannerData: [
        { img: require('../assets/homebg_1.png'), title: '通过提供saas采购数字产品，致力数字化采购 为企业提供采购数字化解决方案', content1: 'PROVIDE ENTERPRISES WITH DIGITAL', content2: 'PROCUREMENT SOLUTIONS' },
        { img: require('../assets/homebg_2.png'), title: '提供自动计算工具，按照企业餐补规则自定义配置，自动计算、发放餐补',   content1: 'Customized configuration, automatic calculation', content2: 'and distribution of meal supplement' },
      ],
      usData: [
        { img: require('../assets/zu37.png'), title: '产品多元化',    content: '不同的使用场景提供正地下的信息化解决方案' },
        { img: require('../assets/zu36.png'), title: '更新迭代迅速',  content: '根据用户体验及行业发展新动向不断迭代更新产品，保证产品的用户体验以及先进性' },
        { img: require('../assets/zu35.png'), title: '多终端适配',    content: 'PC、APP、H5、微信公众号、支付宝小程序、微信小程序以及智能硬件多端互通' },
        { img: require('../assets/ryjjh.png'), title: '软硬件结合',   content: '研发团队具有丰富物联网+的开发经验' },
        { img: require('../assets/zu33.png'), title: '全方位技术支持', content: '1V1专人部署指导，提供操作手册产品手册等文档视频资料，让你快速上手运营' },
        { img: require('../assets/zu34.png'), title: '全天候售后团队', content: '提供6*24小时全班值守快速响应解决技术难题' },
      ],
      productData: [
        { img: require('../assets/slzf.png'),  title: '刷脸支付',  content: '全面聚合扫码收款，微信支付，支付宝支付，云闪付都能用。实现一码收款，方便快捷省时省力。' },
        { img: require('../assets/sh.png'),    title: '商户APP',   content: '随时掌握当日的交易情况，集中进行收款交易，查账对账，数据分析，极速提现，资金增值，营销管理等。功能强大，简单易操作' },
        { img: require('../assets/cjewm.png'), title: '超级二维码', content: '融合支付宝，微信支付，银联，百度钱包等多种支付方式，实现一码收款，方便快捷，省时省力' },
        { img: require('../assets/mjjq.png'),  title: '门禁机器',  content: '门禁的自动化管理，数据还可用于考勤，实现门禁考勤双功能，同时与一卡通系统可以无缝衔接。' },
        { img: require('../assets/pcsyt.png'), title: 'PC收银台',  content: '一个多种支付收款工具，无需对接开发，无需更换设备，只需安装一个应用，收款，核销，电子会员一键搞定。' },
        { img: require('../assets/syt.png'),   title: '自助闸机',  content: '地铁，车站等场所，刷脸识别身份，快速通行' },
      ],
      serviceData: [
        { valueData: [
          { type: '1', img: require('../assets/cb.png'),                  text: '餐补',   html: '提供餐补自动计算工具，按照企业餐补规则自定义配置，自动计算餐补金额，在线发放、自动发放餐补。' },
          { type: '0', img: require('../assets/yudingchenggong.png'),     text: '在线预定', html: '支持通过小程序进行当天或其他日期的菜品预订，支持餐厅配送或个人自取/组织自取。' },
          { type: '0', img: require('../assets/zhifu-2.png'),             text: '员工福利', html: '解决企业餐补多消费场景应用、支持企业的消费、对账、结算、入账等全流程管理，一站式解决大型央国企消费管控繁琐、对账复杂的痛点。' },
          { type: '0', img: require('../assets/yyjk.png'),                text: '运营监控', html: '通过电子大屏/移动端可观测食堂运营情况，包括菜品售卖信息、人流量、档口情况、用餐区人员情况、菜品销售排行等信息监测，同时管理者可对食堂整体交易情况、喜好排行、支付方式排行等情况进行监测。' },
        ] },
        { valueData: [
          { type: '1', img: require('../assets/jzgl.png'),                text: '集中管理', html: '支持多餐厅运营、多组织用餐、跨组织、跨区域用餐、统一结算、分别结算等不同管控模式，满足供餐企业、用餐企业、园区企业的集中管控诉求。' },
          { type: '0', img: require('../assets/biaoqianlan_fuli.png'),    text: '支付方式', html: '支持用户使用人脸识别、个人餐补账户、组织餐补账户、虚拟账户、二维码、实体卡等方式支付。' },
          { type: '0', img: require('../assets/lsgl.png'),                text: '零售管理', html: '支持企业围绕员工生活服务，提供便利店、水果店、休闲吧、咖啡厅、体育馆、干洗店等不同零售场景，以及电商、保险、体检、交通等线上消费场景，使用餐补消费、个人储值消费、卡券消费、企业支付等。' },
          { type: '0', img: require('../assets/dz.png'),                  text: '对账',    html: '支持跨集团、单一集团、单一公司下，跨组织、跨部门消费内部对账；支持微信、支付宝、银行等不同支付渠道的收款对账。' },
        ] },
      ],
      serviceData2: [
        { valueData2: [
          { type: '1', img: require('../assets/cb.png'),              text: '餐补',   html: '提供餐补自动计算工具，按照企业餐补规则自定义配置，自动计算餐补金额，在线发放、自动发放餐补。' },
          { type: '0', img: require('../assets/yudingchenggong.png'), text: '在线预定', html: '支持通过小程序进行当天或其他日期的菜品预订，支持餐厅配送或个人自取/组织自取。' },
          { type: '0', img: require('../assets/zhifu-2.png'),         text: '员工福利', html: '解决企业餐补多消费场景应用、支持企业的消费、对账、结算、入账等全流程管理，一站式解决大型央国企消费管控繁琐、对账复杂的痛点。' },
        ] },
        { valueData2: [
          { type: '1', img: require('../assets/yyjk.png'),            text: '运营监控', html: '通过电子大屏/移动端可观测食堂运营情况。' },
          { type: '0', img: require('../assets/jzgl.png'),            text: '集中管理', html: '支持多餐厅运营、多组织用餐、跨组织、跨区域用餐。' },
          { type: '0', img: require('../assets/biaoqianlan_fuli.png'),text: '支付方式', html: '支持用户使用人脸识别、个人餐补账户、组织餐补账户、虚拟账户、二维码、实体卡等方式支付。' },
        ] },
        { valueData2: [
          { type: '1', img: require('../assets/lsgl.png'), text: '零售管理', html: '支持企业围绕员工生活服务，提供多种零售场景。' },
          { type: '0', img: require('../assets/dz.png'),   text: '对账',    html: '支持跨集团、单一集团、单一公司下，跨组织、跨部门消费内部对账。' },
        ] },
      ],
      cooperationData: [
        { img: require('../assets/co1.png') },  { img: require('../assets/co2.png') },
        { img: require('../assets/co3.png') },  { img: require('../assets/co4.png') },
        { img: require('../assets/co5.png') },  { img: require('../assets/co6.png') },
        { img: require('../assets/co7.png') },  { img: require('../assets/co8.png') },
        { img: require('../assets/co9.png') },  { img: require('../assets/co10.png') },
        { img: require('../assets/co11.png') }, { img: require('../assets/co12.png') },
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      this._initCursorGlow()
      this._initHeroAnimations()
      this._initStatsCounters()
      this._initHorizontalScroll()
      this._initSectionReveals()
      this._initAppSection()
      this._initServiceCards()
      this._initTicker()
      this._initWhyCards()
      this._initPartners()
      this._initMagneticButtons()
      this._initOrbParallax()
      this._initCard3DTilt()
    })
  },

  beforeDestroy() {
    ScrollTrigger.getAll().forEach(t => t.kill())
    document.removeEventListener('mousemove', this._cursorHandler)
  },

  computed: {
    /** 将两页服务数据展平为单一数组 */
    flatServiceItems() {
      return this.serviceData.flatMap(slide => slide.valueData)
    },
    /** 三倍复制 Logo，供无限跑马灯无缝循环 */
    marqueeLogos() {
      return [
        ...this.cooperationData,
        ...this.cooperationData,
        ...this.cooperationData,
      ]
    },
  },

  methods: {
    /* ─────────────────────────────────────────────
       1. 鼠标光晕（cursor glow）
    ───────────────────────────────────────────── */
    _initCursorGlow() {
      const glow = this.$refs.cursorGlow
      if (!glow) return
      this._cursorHandler = (e) => {
        gsap.to(glow, {
          x: e.clientX, y: e.clientY,
          duration: 0.6, ease: 'power2.out',
        })
      }
      document.addEventListener('mousemove', this._cursorHandler)
    },

    /* ─────────────────────────────────────────────
       2. Hero 入场动画 + 光球浮动
    ───────────────────────────────────────────── */
    _initHeroAnimations() {
      const ease = 'expo.out'
      const tl = gsap.timeline({ delay: 0.3 })

      /* badge 弹入 */
      tl.from(this.$refs.heroBadge, {
        scale: 0, opacity: 0, duration: 0.5, ease: 'back.out(2)',
      })

      /* 标题 & 副标题：clip-path 遮幕揭示 */
      tl.from('.clip-inner', {
        yPercent: 105, opacity: 0,
        duration: 1, ease, stagger: 0.18,
      }, '-=0.2')

      /* 按钮错落淡入 */
      tl.from(this.$refs.heroActions?.children || [], {
        y: 24, opacity: 0,
        duration: 0.6, ease: 'power3.out', stagger: 0.12,
      }, '-=0.5')

      /* 光球持续浮动 */
      const floatOrb = (ref, config) => {
        if (!this.$refs[ref]) return
        gsap.to(this.$refs[ref], { ...config, repeat: -1, yoyo: true, ease: 'sine.inOut' })
      }
      floatOrb('orb1', { y: -50, x: 30,  duration: 5 })
      floatOrb('orb2', { y: 35,  x: -40, duration: 6.5, delay: 1 })
      floatOrb('orb3', { y: -30, x: 20,  duration: 4,   delay: 0.5 })
    },

    /* ─────────────────────────────────────────────
       3. 统计数字滚动计数
    ───────────────────────────────────────────── */
    _initStatsCounters() {
      const items = this.$el.querySelectorAll('.stat-item__num')
      items.forEach((el) => {
        const target = parseInt(el.dataset.target, 10)
        gsap.fromTo(el,
          { innerHTML: 0 },
          {
            innerHTML: target,
            duration: 2.2,
            ease: 'power2.out',
            snap: { innerHTML: 1 },
            scrollTrigger: { trigger: el, start: 'top 90%', once: true },
          }
        )
      })
      /* 整个 stats bar 淡入上升 */
      gsap.fromTo(this.$refs.statsBar,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.9, ease: 'expo.out',
          scrollTrigger: { trigger: this.$refs.statsBar, start: 'top 88%', once: true },
          clearProps: 'transform,opacity' }
      )
    },

    /* ─────────────────────────────────────────────
       4. 产品区域：水平钉住滚动
    ───────────────────────────────────────────── */
    _initHorizontalScroll() {
      const section  = this.$refs.prodSection
      const track    = this.$refs.prodTrack
      const overflow = this.$refs.prodOverflow
      const fill     = this.$refs.progressFill
      if (!section || !track || !overflow) return

      const getAmt = () => -(track.scrollWidth - overflow.offsetWidth + 40)

      /* 左侧文字先揭示 */
      gsap.fromTo([this.$refs.prodTitle, this.$refs.prodDesc],
        { yPercent: 100, opacity: 0 },
        { yPercent: 0, opacity: 1, duration: 0.9, ease: 'expo.out', stagger: 0.15,
          scrollTrigger: { trigger: section, start: 'top 80%', once: true },
          clearProps: 'transform,opacity' }
      )

      /* 水平滚动 + 进度条 */
      gsap.to(track, {
        x: getAmt,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: () => `+=${Math.abs(getAmt())}`,
          pin: true,
          scrub: 0.8,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            if (fill) gsap.set(fill, { scaleX: self.progress, transformOrigin: 'left' })
          },
        },
      })
    },

    /* ─────────────────────────────────────────────
       5. 各 Section 标题遮幕揭示 + chip 淡入
    ───────────────────────────────────────────── */
    _initSectionReveals() {
      /* chip 标签 */
      this.$el.querySelectorAll('.reveal-chip').forEach((el) => {
        gsap.fromTo(el,
          { x: -20, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
            scrollTrigger: { trigger: el, start: 'top 88%', once: true },
            clearProps: 'transform,opacity' }
        )
      })

      /* 标题 title-mask 揭示 */
      this.$el.querySelectorAll('.title-mask__inner').forEach((el) => {
        gsap.fromTo(el,
          { yPercent: 110 },
          { yPercent: 0, duration: 1, ease: 'expo.out',
            scrollTrigger: { trigger: el, start: 'top 88%', once: true },
            clearProps: 'transform' }
        )
      })

      /* desc 淡入 */
      this.$el.querySelectorAll('.sec__desc').forEach((el) => {
        gsap.fromTo(el,
          { y: 16, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', delay: 0.3,
            scrollTrigger: { trigger: el, start: 'top 90%', once: true },
            clearProps: 'transform,opacity' }
        )
      })
    },

    /* ─────────────────────────────────────────────
       6. APP 介绍：图片 scrub 3D 从右划入 + 文字 scrub 逐项响应
    ───────────────────────────────────────────── */
    _initAppSection() {
      const section = this.$refs.appSection
      if (!section) return

      /* 图片：scrub 3D 透视从右侧滑入 */
      gsap.fromTo(this.$refs.appImg,
        { x: 100, opacity: 0, rotateY: 25, transformPerspective: 900 },
        {
          x: 0, opacity: 1, rotateY: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: section, start: 'top 75%', end: 'center 45%', scrub: 0.8,
          },
          clearProps: 'transform,opacity',
        }
      )

      /* 图片持续视差 */
      gsap.to(this.$refs.appImg, {
        y: -60, ease: 'none',
        scrollTrigger: { trigger: section, scrub: 1.5, start: 'top bottom', end: 'bottom top' },
      })

      /* 功能特性：每条逐一 scrub 响应滚动位置 */
      const feats = Array.from(this.$el.querySelectorAll('.app-feat-item'))
      feats.forEach((el, i) => {
        gsap.fromTo(el,
          { x: -50, opacity: 0 },
          {
            x: 0, opacity: 1, ease: 'none',
            scrollTrigger: {
              trigger: el,
              start: 'top 90%',
              end: 'top 65%',
              scrub: 0.5,
            },
            clearProps: 'transform,opacity',
          }
        )
      })

      /* 下载按钮：scrub scale 弹入 */
      const btn = section.querySelector('.btn-primary')
      if (btn) {
        gsap.fromTo(btn,
          { scale: 0.7, opacity: 0 },
          {
            scale: 1, opacity: 1, ease: 'none',
            scrollTrigger: { trigger: btn, start: 'top 90%', end: 'top 70%', scrub: 0.6 },
            clearProps: 'transform,opacity',
          }
        )
      }
    },

    /* ─────────────────────────────────────────────
       7. 服务卡片：clip-path 从下到上遮幕揭示
    ───────────────────────────────────────────── */
    _initServiceCards() {
      const cards = Array.from(this.$el.querySelectorAll('.svc-card'))
      if (!cards.length) return

      /* 构建 scrub timeline，卡片随滚动逐列解锁 */
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cards[0],
          start: 'top 85%',
          end: 'top 35%',
          scrub: 0.6,
        },
      })
      cards.forEach((card, i) => {
        tl.fromTo(card,
          { clipPath: 'inset(100% 0 0 0)', opacity: 0.4 },
          { clipPath: 'inset(0% 0 0 0)', opacity: 1, ease: 'expo.out', duration: 0.6 },
          i * 0.05          /* 每张错开 0.05 单位 */
        )
      })
    },

    /* ─────────────────────────────────────────────
       8. Ticker 横向关键字跑马灯
    ───────────────────────────────────────────── */
    _initTicker() {
      const track = this.$refs.tickerTrack
      if (!track) return
      gsap.to(track, {
        x: '-50%',
        duration: 22,
        ease: 'none',
        repeat: -1,
      })
    },

    /* ─────────────────────────────────────────────
       9. Why 卡片：scrub timeline + 扫描线同步
    ───────────────────────────────────────────── */
    _initWhyCards() {
      const section  = this.$refs.whySection
      const scanLine = this.$refs.whyScanLine
      const cards    = Array.from(this.$el.querySelectorAll('.why-card'))
      if (!section || !cards.length) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 68%',
          end: 'center 30%',
          scrub: 0.7,
        },
      })

      /* 扫描线从左到右随滚动扫过 */
      if (scanLine) {
        tl.fromTo(scanLine,
          { scaleX: 0 },
          { scaleX: 1, duration: 1 },
          0
        )
      }

      /* 第一排（索引 0–2）先出现 */
      tl.fromTo(cards.slice(0, 3),
        { y: 70, opacity: 0, scale: 0.88, rotateX: 12, transformPerspective: 1000 },
        { y: 0, opacity: 1, scale: 1, rotateX: 0, duration: 0.6, stagger: 0.08 },
        0.15
      )
      /* 第二排（索引 3–5）稍后跟上 */
      tl.fromTo(cards.slice(3),
        { y: 70, opacity: 0, scale: 0.88, rotateX: 12, transformPerspective: 1000 },
        { y: 0, opacity: 1, scale: 1, rotateX: 0, duration: 0.6, stagger: 0.08 },
        0.45
      )
    },

    /* ─────────────────────────────────────────────
       10. 合作伙伴：无限自动跑马灯（hover 暂停）
    ───────────────────────────────────────────── */
    _initPartners() {
      const track = this.$refs.marqueeTrack
      if (!track) return

      this._marqueeTween = gsap.to(track, {
        x: '-33.333%',
        duration: 28,
        ease: 'none',
        repeat: -1,
      })

      track.addEventListener('mouseenter', () => this._marqueeTween.pause())
      track.addEventListener('mouseleave', () => this._marqueeTween.play())

      /* 合作伙伴标题入场 */
      const head = this.$refs.partnerHead
      if (head) {
        gsap.fromTo(head,
          { y: 40, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.8, ease: 'expo.out',
            scrollTrigger: { trigger: head, start: 'top 88%', once: true },
            clearProps: 'transform,opacity' }
        )
      }
    },

    /* ─────────────────────────────────────────────
       9. 磁性按钮跟随鼠标
    ───────────────────────────────────────────── */
    _initMagneticButtons() {
      const btns = this.$el.querySelectorAll('.magnetic')
      btns.forEach((btn) => {
        btn.addEventListener('mousemove', (e) => {
          const r = btn.getBoundingClientRect()
          const x = (e.clientX - r.left - r.width  / 2) * 0.35
          const y = (e.clientY - r.top  - r.height / 2) * 0.35
          gsap.to(btn, { x, y, duration: 0.3, ease: 'power2.out' })
        })
        btn.addEventListener('mouseleave', () => {
          gsap.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.5)' })
        })
      })
    },

    /* ─────────────────────────────────────────────
       10. 光球滚动视差
    ───────────────────────────────────────────── */
    _initOrbParallax() {
      const hero = this.$refs.hero
      if (!hero) return
      if (this.$refs.orb1) {
        gsap.to(this.$refs.orb1, { y: -120, ease: 'none',
          scrollTrigger: { trigger: hero, scrub: 1, start: 'top top', end: 'bottom top' } })
      }
      if (this.$refs.orb2) {
        gsap.to(this.$refs.orb2, { y: -70, ease: 'none',
          scrollTrigger: { trigger: hero, scrub: 1.5, start: 'top top', end: 'bottom top' } })
      }
    },

    /* ─────────────────────────────────────────────
       11. 产品卡片 3D 倾斜 hover
    ───────────────────────────────────────────── */
    _initCard3DTilt() {
      const cards = this.$el.querySelectorAll('.prod-card')
      cards.forEach((card) => {
        card.addEventListener('mousemove', (e) => {
          const r = card.getBoundingClientRect()
          const x = (e.clientX - r.left) / r.width  - 0.5
          const y = (e.clientY - r.top)  / r.height - 0.5
          gsap.to(card, {
            rotateY: x * 18, rotateX: -y * 18,
            transformPerspective: 800,
            duration: 0.3, ease: 'power2.out',
          })
        })
        card.addEventListener('mouseleave', () => {
          gsap.to(card, {
            rotateY: 0, rotateX: 0,
            duration: 0.7, ease: 'elastic.out(1, 0.6)',
          })
        })
      })
    },

    /* ─── 轮播切换时重跑 clip-inner 动画 ─── */
    onSlideChange() {
      gsap.fromTo('.clip-inner',
        { yPercent: 100, opacity: 0 },
        { yPercent: 0, opacity: 1, duration: 0.9, ease: 'expo.out', stagger: 0.15 }
      )
    },

    /* ─── 服务价值 hover ─── */
    onMouseOver(item) {
      this.serviceData.forEach(s => s.valueData.forEach(e => this.$set(e, 'type', '0')))
      this.$set(item, 'type', '1')
    },
    onMouseOut() {
      this.serviceData.forEach(s => s.valueData.forEach((e, i) => this.$set(e, 'type', i === 0 ? '1' : '0')))
    },
    onMouseOver2(item) {
      this.serviceData2.forEach(s => s.valueData2.forEach(e => this.$set(e, 'type', '0')))
      this.$set(item, 'type', '1')
    },
    onMouseOut2() {
      this.serviceData2.forEach(s => s.valueData2.forEach((e, i) => this.$set(e, 'type', i === 0 ? '1' : '0')))
    },

    applyShow() { this.show = true; this.noScroll() },

    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    downlink() {
      if (this.isMobile()) {
        if (/Android/.test(navigator.userAgent)) { this.down('./static/hnx.apk') }
        else if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) { this.down('https://apps.apple.com/cn/app/%E7%B3%96%E5%BE%B7-%E6%99%BA%E8%83%BD%E7%BB%88%E7%AB%AF/id6450306698') }
      } else { this.down('./static/hnx.apk') }
    },
    down(val) { const a = document.createElement('a'); a.href = val; a.click(); a.remove() },
  },
}
</script>

<style lang="scss" scoped>
/* ──────────────────── 令牌 ──────────────────── */
$blue:    #0E6EB8;
$blue-l:  #38A0F5;
$dark:    #0D1B2E;
$tint:    #F0F7FF;
$muted:   #6B7280;
$r-xl:    1.25rem;
$shadow:  0 8px 32px rgba(14,110,184,.15);
$tr:      all .3s cubic-bezier(.4,0,.2,1);

/* ──────────────────── Cursor glow ──────────────────── */
.cursor-glow {
  position: fixed;
  width: 28rem;
  height: 28rem;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(14,110,184,.12), transparent 70%);
  pointer-events: none;
  transform: translate(-50%, -50%);
  z-index: 9990;
  mix-blend-mode: screen;
  will-change: transform;
}

/* ──────────────────── Hero ──────────────────── */
.hero {
  height: 50.3125rem;
  position: relative;
  overflow: hidden;

  /* 悬浮光球 */
  .orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    pointer-events: none;
    z-index: 2;
    will-change: transform;
  }
  .orb--1 { width: 42rem; height: 42rem; background: rgba(14,110,184,.28); top: -12rem; right: -6rem; }
  .orb--2 { width: 28rem; height: 28rem; background: rgba(56,160,245,.22); bottom: 3rem;  left: 42%; }
  .orb--3 { width: 20rem; height: 20rem; background: rgba(30,200,255,.16); top: 35%;    left: 8%; }
}

.hero__slide {
  width: 100%; height: 100%;
  background-size: cover;
  background-position: center;
  display: flex; align-items: center;
  position: relative;
}
.hero__overlay {
  position: absolute; inset: 0;
  background: linear-gradient(110deg, rgba(8,30,64,.78) 0%, rgba(14,110,184,.38) 55%, rgba(0,0,0,.05) 100%);
  z-index: 1;
}
.hero__body {
  position: relative; z-index: 3;
  padding: 0 7.5rem;
  max-width: 55%;
}

/* Clip-path 文字遮幕 */
.clip-wrap {
  overflow: hidden;
  line-height: 1;
}
.clip-inner { display: block; }

.hero__badge {
  display: inline-flex; align-items: center; gap: .5rem;
  background: rgba(255,255,255,.12);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,.25);
  color: #fff; font-size: .78rem; font-weight: 600; letter-spacing: .08em;
  padding: .38rem .95rem; border-radius: 5rem; margin-bottom: 1.2rem;
}
.hero__dot {
  width: .45rem; height: .45rem; border-radius: 50%;
  background: $blue-l; animation: pulse 2s infinite;
}
.hero__title {
  font-size: 1.9rem; font-weight: 800; color: #fff;
  line-height: 1.45; margin: 0 0 .8rem;
  text-shadow: 0 2px 20px rgba(0,0,0,.35);
}
.hero__sub {
  font-size: .78rem; color: rgba(255,255,255,.72);
  letter-spacing: .05em; margin: 0 0 2rem; line-height: 1.8;
}
.hero__actions {
  display: flex; gap: 1rem; flex-wrap: wrap;
}

/* ──────────────────── 按钮 ──────────────────── */
.btn-primary {
  padding: .9rem 2.4rem;
  background: linear-gradient(135deg, $blue, $blue-l);
  color: #fff; font-size: .95rem; font-weight: 700;
  border-radius: 3rem; border: none; cursor: pointer;
  box-shadow: 0 6px 20px rgba(14,110,184,.4);
  transition: $tr; will-change: transform;

  &:hover { box-shadow: 0 10px 30px rgba(14,110,184,.55); }
}
.btn-ghost {
  padding: .9rem 2.4rem;
  background: rgba(255,255,255,.12);
  color: #fff; font-size: .95rem; font-weight: 700;
  border-radius: 3rem; border: 1.5px solid rgba(255,255,255,.45);
  cursor: pointer; transition: $tr; backdrop-filter: blur(8px);
  will-change: transform;

  &:hover { background: rgba(255,255,255,.22); border-color: #fff; }
}

/* ──────────────────── Stats Bar ──────────────────── */
.stats-bar {
  background: linear-gradient(135deg, $dark 0%, #0e2a4a 100%);
  padding: 2.5rem 7.5rem;

  &__inner {
    display: flex; justify-content: space-around; align-items: center;
    max-width: 1200px; margin: 0 auto;
  }
}
.stat-item {
  text-align: center; position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute; right: -3rem; top: 50%;
    transform: translateY(-50%);
    width: 1px; height: 2.5rem;
    background: rgba(255,255,255,.15);
  }

  &__num-wrap {
    display: flex; align-items: baseline; justify-content: center;
    gap: .15rem; margin-bottom: .4rem;
  }
  &__num  { font-size: 2.8rem; font-weight: 900; color: #fff; line-height: 1; }
  &__unit { font-size: 1rem; font-weight: 700; color: $blue-l; }
  &__label { font-size: .8rem; color: rgba(255,255,255,.55); letter-spacing: .06em; }
}

/* ──────────────────── 产品横向滚动 ──────────────────── */
.prod-section {
  background: $tint;
  overflow: hidden;
}
.prod-container {
  display: flex;
  align-items: stretch;
  height: 100vh;
  padding: 0 0 0 7.5rem;
}
.prod-left {
  flex: 0 0 22rem;
  display: flex; flex-direction: column; justify-content: center;
  padding-right: 2rem;

  .sec__label { display: inline-block; margin-bottom: .75rem; }

  .title-mask {
    overflow: hidden; margin-bottom: 1rem;
  }
  .title-mask__inner {
    font-size: 2.4rem; font-weight: 800; color: #1A2535;
    line-height: 1.2; margin: 0;
  }
  .sec__desc { font-size: .95rem; color: $muted; line-height: 1.7; margin: 0 0 2rem; }
}
.prod-progress {
  width: 8rem;
  height: 3px;
  background: rgba(14,110,184,.15);
  border-radius: 2px;
  overflow: hidden;

  &__fill {
    height: 100%;
    background: linear-gradient(90deg, $blue, $blue-l);
    transform-origin: left;
    transform: scaleX(0);
    border-radius: 2px;
  }
}
.prod-overflow {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 2rem 0;
}
.prod-track {
  display: flex;
  gap: 1.5rem;
  will-change: transform;
  padding-right: 7.5rem;
}

/* 产品卡（横向轨道内） */
.prod-card {
  flex: 0 0 22rem;
  background: #fff;
  border-radius: $r-xl;
  overflow: hidden;
  border: 1px solid rgba(14,110,184,.1);
  box-shadow: 0 4px 20px rgba(14,110,184,.08);
  transition: box-shadow .3s ease, border-color .3s ease;
  will-change: transform;
  transform-style: preserve-3d;
  cursor: default;

  &:hover {
    box-shadow: 0 20px 50px rgba(14,110,184,.22);
    border-color: rgba(14,110,184,.3);

    .prod-card__img img { transform: scale(1.07); }
  }

  &__img {
    width: 100%;
    height: 13rem;
    overflow: hidden;
    background: #eef5fb;

    img { width: 100%; height: 100%; object-fit: cover; transition: transform .5s ease; }
  }

  &__body {
    padding: 1.4rem 1.6rem 1.75rem;

    h3 { font-size: 1.15rem; font-weight: 800; color: #1A2535; margin: 0 0 .6rem; }
    p  { font-size: .875rem; color: $muted; line-height: 1.7; margin: 0; }
  }
}

/* ──────────────────── 服务价值特性卡片网格 ──────────────────── */
.sec--svc {
  background: linear-gradient(180deg, #fff 0%, $tint 100%);
}

.svc-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;
}

.svc-card {
  position: relative;
  background: #fff;
  border: 1px solid rgba(14,110,184,.1);
  border-radius: $r-xl;
  padding: 2rem 1.6rem 1.75rem;
  overflow: hidden;
  cursor: default;
  transition: transform .3s cubic-bezier(.4,0,.2,1),
              box-shadow .3s cubic-bezier(.4,0,.2,1),
              border-color .3s ease;

  /* 序号角标 */
  &__index {
    position: absolute; top: 1.25rem; right: 1.4rem;
    font-size: .75rem; font-weight: 800; color: rgba(14,110,184,.18);
    letter-spacing: .05em;
  }

  /* 底部扫光线：hover 时从左到右展开 */
  &__line {
    position: absolute; bottom: 0; left: 0; right: 0;
    height: 3px;
    background: linear-gradient(90deg, $blue, $blue-l);
    transform: scaleX(0);
    transform-origin: left;
    border-radius: 3px 3px 0 0;
    transition: transform .4s cubic-bezier(.4,0,.2,1);
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(14,110,184,.15);
    border-color: rgba(14,110,184,.25);

    .svc-card__line  { transform: scaleX(1); }
    .svc-card__icon  { background: linear-gradient(135deg, rgba(14,110,184,.18), rgba(56,160,245,.1)); transform: scale(1.08) rotate(-4deg); }
    .svc-card__title { color: $blue; }
  }

  &__icon {
    width: 3.5rem; height: 3.5rem;
    background: linear-gradient(135deg, rgba(14,110,184,.1), rgba(56,160,245,.06));
    border-radius: .875rem;
    border: 1px solid rgba(14,110,184,.12);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.25rem;
    transition: background .3s ease, transform .35s cubic-bezier(.34,1.56,.64,1);

    img { width: 2rem; height: 2rem; object-fit: contain; }
  }

  &__title {
    font-size: 1.05rem; font-weight: 800; color: #1A2535;
    margin: 0 0 .65rem;
    transition: color .25s ease;
  }

  &__desc {
    font-size: .82rem; color: $muted;
    line-height: 1.8; margin: 0;
    /* 最多 4 行，超出省略 */
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

/* ──────────────────── Section 通用 ──────────────────── */
.sec {
  padding: 5rem 7.5rem;

  &--white { background: #fff; }
  &--tint  { background: $tint; }
  &--dark  { background: $dark; }

  &__inner { max-width: 1400px; margin: 0 auto; }

  &__head { text-align: center; margin-bottom: 3.5rem; }

  &__label {
    display: inline-block;
    font-size: .72rem; font-weight: 700; letter-spacing: .2em;
    color: $blue; background: rgba(14,110,184,.09);
    padding: .3rem .9rem; border-radius: 5rem; margin-bottom: .8rem;

    &--light { color: $blue-l; background: rgba(56,160,245,.12); }
  }

  .title-mask { overflow: hidden; }
  .title-mask__inner {
    display: block;
    font-size: 2.4rem; font-weight: 800; color: #1A2535; margin: 0 0 .7rem;
    &--light { color: #fff; }
  }

  &__title {
    font-size: 2.4rem; font-weight: 800; color: #1A2535; margin: 0 0 .7rem;
    &--light { color: #fff; }
  }

  &__desc { font-size: .95rem; color: $muted; margin: 0;
    &--light { color: rgba(255,255,255,.6); }
  }
}

/* ──────────────────── APP Section ──────────────────── */
.app-section {
  display: flex; align-items: center; gap: 5rem;

  &__text {
    flex: 1;
    .sec__label { display: inline-block; margin-bottom: .75rem; }
  }

  &__img {
    flex: 0 0 16rem;
    position: relative;
    display: flex; justify-content: center;
    will-change: transform;

    img { width: 100%; filter: drop-shadow(0 20px 40px rgba(14,110,184,.2)); }
  }
}
.app-img-glow {
  position: absolute; inset: 10%;
  background: radial-gradient(circle, rgba(56,160,245,.3), transparent 70%);
  border-radius: 50%;
  animation: glowPulse 3s ease-in-out infinite;
}
@keyframes glowPulse {
  0%,100% { opacity: .6; transform: scale(1); }
  50%      { opacity: 1;  transform: scale(1.15); }
}

.app-intro {
  font-size: .9rem; color: $muted; line-height: 1.85; margin: 1rem 0 1.5rem;
}
.app-feat-title {
  font-size: 1.1rem; font-weight: 800; color: #1A2535; margin: 0 0 1rem;
}
.app-feat-list { list-style: none; padding: 0; margin: 0 0 2rem; display: flex; flex-direction: column; gap: .8rem; }
.app-feat-item {
  display: flex; gap: .75rem; align-items: flex-start;
  font-size: .875rem; color: $muted; line-height: 1.65;
}
.feat-num {
  flex-shrink: 0;
  width: 1.6rem; height: 1.6rem; border-radius: 50%;
  background: linear-gradient(135deg, $blue, $blue-l);
  color: #fff; font-size: .68rem; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  margin-top: .05rem;
}

/* FZ版手风琴（隐藏区域保留样式供备用） */
.service-wrap { border-radius: 1rem; overflow: hidden; }
.service_bao  { display: flex; align-items: stretch; justify-content: center; height: 100%; gap: .75rem; padding: 0 1rem; }
.service_hover {
  width: 22rem; height: 33.3125rem; position: relative;
  display: flex; align-items: center; justify-content: center;
  border-radius: $r-xl; overflow: hidden;
  & > img { width: 100%; height: 100%; object-fit: cover; border-radius: $r-xl; }
  &__text { position: absolute; width: 75%; display: flex; flex-direction: column; }
  &__line { width: 2.5rem; height: 3px; background: #fff; display: block; margin: 1rem 0; }
}
.service_zhan {
  min-width: 9rem; height: 33.3125rem; background: #fff;
  border: 1.5px solid rgba(14,110,184,.12); border-radius: $r-xl;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  img  { width: 4rem; height: 4rem; object-fit: contain; }
  span { font-size: 1.1rem; font-weight: 700; color: #1A2535; margin-top: 1.5rem; }
}

/* ──────────────────── Why Choose Us ──────────────────── */
.why-section { position: relative; overflow: hidden; }
.why-grid-bg {
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(56,160,245,.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56,160,245,.04) 1px, transparent 1px);
  background-size: 60px 60px;
  pointer-events: none;
}
.why-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem;
}
.why-card {
  background: rgba(255,255,255,.05);
  border: 1px solid rgba(255,255,255,.1);
  border-radius: $r-xl; padding: 2rem 1.75rem;
  transition: $tr; cursor: default;
  will-change: transform;

  &:hover {
    background: rgba(255,255,255,.1);
    border-color: rgba(56,160,245,.45);
    transform: translateY(-6px);
    box-shadow: 0 14px 40px rgba(0,0,0,.3);
    .why-card__icon { background: linear-gradient(135deg, rgba(14,110,184,.4), rgba(56,160,245,.25)); }
  }

  &__icon {
    width: 4rem; height: 4rem;
    background: linear-gradient(135deg, rgba(14,110,184,.25), rgba(56,160,245,.12));
    border-radius: .875rem; border: 1px solid rgba(56,160,245,.2);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.25rem; transition: $tr;

    img { width: 2.2rem; height: 2.2rem; object-fit: contain; filter: brightness(0) invert(1) opacity(.85); }
  }

  &__title { font-size: 1.05rem; font-weight: 800; color: #fff; margin: 0 0 .6rem; }
  &__text  { font-size: .875rem; color: rgba(255,255,255,.58); line-height: 1.7; margin: 0; }
}

/* ──────────────────── Why 扫描线 ──────────────────── */
.why-scan-line {
  position: absolute; top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, $blue-l 40%, $blue 60%, transparent 100%);
  transform-origin: left;
  transform: scaleX(0);
  z-index: 2;
  pointer-events: none;
  box-shadow: 0 0 20px rgba(56,160,245,.8);
}

/* ──────────────────── Ticker Band ──────────────────── */
.ticker-band {
  background: $dark;
  padding: .9rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(255,255,255,.07);
  border-bottom: 1px solid rgba(255,255,255,.07);
}
.ticker-track {
  display: inline-flex;
  white-space: nowrap;
  will-change: transform;
}
.ticker-item {
  display: inline-flex; align-items: center; gap: .5rem;
  font-size: .78rem; font-weight: 700; letter-spacing: .15em;
  text-transform: uppercase;
  color: rgba(255,255,255,.35);
  padding: 0 2.5rem;

  /* 菱形分隔 */
  &::before {
    content: '◆';
    color: $blue-l;
    font-size: .5rem;
  }
}

/* ──────────────────── Partner 跑马灯 ──────────────────── */
.partner-section { background: $tint; }

.marquee-outer {
  overflow: hidden;
  padding: 1rem 0 2rem;
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}
.marquee-track {
  display: inline-flex;
  will-change: transform;
}
.marquee-logo {
  flex-shrink: 0;
  width: 11rem; height: 6rem;
  margin: 0 1rem;
  display: flex; align-items: center; justify-content: center;
  background: #fff;
  border: 1px solid rgba(14,110,184,.1);
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 12px rgba(14,110,184,.06);
  transition: transform .3s ease, box-shadow .3s ease, border-color .3s ease;
  cursor: default;

  &:hover {
    transform: scale(1.06);
    box-shadow: 0 8px 28px rgba(14,110,184,.18);
    border-color: rgba(14,110,184,.3);
  }
  img { max-width: 100%; max-height: 100%; object-fit: contain; }
}

/* ──────────────────── Keyframes ──────────────────── */
@keyframes pulse {
  0%,100% { opacity: 1; transform: scale(1); }
  50%      { opacity: .5; transform: scale(1.4); }
}
</style>

<style>
@media screen and (max-width: 600px) {
  .cursor-glow { display: none; }
  .prod-container { flex-direction: column !important; height: auto !important; padding: 3rem 1.5rem !important; }
  .prod-left { flex: none !important; }
  .prod-track { flex-direction: column !important; }
  .prod-card  { flex: none !important; width: 100% !important; }
  .app-section { flex-direction: column !important; }
  .why-grid { grid-template-columns: 1fr !important; }
  .partner-grid { grid-template-columns: repeat(2, 1fr) !important; }
  .stats-bar { padding: 2rem 1.5rem !important; }
  .stats-bar__inner { flex-wrap: wrap; gap: 1.5rem; }
  .stat-item::after { display: none !important; }
}
</style>
